module.exports = __webpack_public_path__ + "static/color-metallic.c23701af.png";